import React from 'react'
import { useTranslation } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'
import styles from './styles.module.scss'

export const TilesMobileCarousel = () => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)

  return (
    <div className='container'>
      <div className={`row ${styles.mobileCarousel}`}>
        {['tile1', 'tile2', 'tile3'].map((key) => (
          <div
            key={key}
            className={`col-8 col-sm-5 d-flex ${styles.mobileTile} mc-px-2`}
          >
            <div className={`${styles.tileContainer} mc-p-8 mc-corners--md`}>
              <h3 className={`${styles.stepNumber} mc-text--bold mc-mb-4`}>
                {t(`howItWorksTiles.${key}.stepNumber`)}
              </h3>
              <h4 className='mc-text-h2 mc-mb-4'>
                {t(`howItWorksTiles.${key}.title`)}
              </h4>
              <div className={`${styles.underscore} mc-mb-4`}></div>
              <p className='mc-text-h4 mc-text-color--tint mc-mb-4'>
                {t(`howItWorksTiles.${key}.description`)}
              </p>
              <p className='mc-text-small'>
                {t(`howItWorksTiles.${key}.disclaimer`)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
